import CreateApproveLevelClaimModalHook from './CreateApproveLevelClaimModal.hook'
import { AmountWrapper, BodyStyled, FormItem, IconSvg, InputNumberStyled, Modal } from './styles'
import { Form, Input } from 'antd'
import { IMAGE_URL } from '@/constant/IMAGE'

export default function CreateApproveLevelClaimModal() {
  const {
    createClaimApprovalLevelModal,
    onCancelModal,
    form,
    onFinish,
    onHandleSubmit,
    isPendingApprover,
    isSubmitDisabled,
    setIsSubmitDisabled,
  } = CreateApproveLevelClaimModalHook()

  return (
    <Modal
      title={createClaimApprovalLevelModal.record ? 'แก้ไขระดับอนุมัติ' : 'เพิ่มระดับอนุมัติ'}
      open={createClaimApprovalLevelModal.open}
      closable={false}
      cancelText="ยกเลิก"
      okText="บันทึก"
      onOk={onHandleSubmit}
      onCancel={() => onCancelModal()}
      width={720}
      data-testid="add-create-approval-modal"
      centered
      loading={isPendingApprover}
      confirmLoading={isPendingApprover}
      okButtonProps={{ disabled: isSubmitDisabled, loading: isPendingApprover }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        validateTrigger="onChange"
        onValuesChange={() => {
          const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0)
          const values = form.getFieldsValue(['approvalLevelName', 'amountMin', 'amountMax'])
          const allFilled = ['approvalLevelName', 'amountMin', 'amountMax'].every((k) => {
            const v = (values as any)[k]
            return v !== undefined && v !== null && v !== ''
          })
          setIsSubmitDisabled(!allFilled || hasErrors)
        }}
      >
        <BodyStyled>
          <FormItem
            label="ชื่อระดับการอนุมัติ"
            name="approvalLevelName"
            rules={[
              {
                required: true,
                message: 'กรุณาระบุชื่อระดับการอนุมัติ',
              },
            ]}
          >
            <Input placeholder="ระบุ" />
          </FormItem>
          <AmountWrapper>
            <FormItem
              label="จำนวนเงินขั้นต่ำ (บาท)"
              name="amountMin"
              rules={[
                {
                  required: true,
                  message: 'กรุณาระบุจำนวนเงินขั้นต่ำ',
                },
              ]}
            >
              <InputNumberStyled
                formatter={(value?: number | string) =>
                  value !== undefined && value !== null && value !== ''
                    ? `${String(value)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    : ''
                }
                parser={(value?: string) => {
                  const cleaned = String(value ?? '').replace(/\$\s?|(,*)/g, '')
                  return cleaned === '' ? undefined : Number(cleaned)
                }}
                min={0}
                step={1}
                precision={0}
                placeholder="0"
                onChange={(val) => {
                  // เมื่อผู้ใช้ลบค่า ให้เก็บเป็น undefined (ไม่แสดงเป็น 0)
                  if (val === null || val === undefined || val === '') {
                    form.setFieldsValue({ amountMin: undefined })
                  }

                  form.setFieldsValue({ amountMin: val })
                }}
              />
            </FormItem>
            <IconSvg src={IMAGE_URL.minusIcon} alt="minus-icon" />
            <FormItem
              label="จำนวนเงินสูงสุด (บาท)"
              name="amountMax"
              rules={[
                {
                  required: true,
                  message: 'กรุณาระบุจำนวนเงินสูงสุด',
                },
              ]}
            >
              <InputNumberStyled
                formatter={(value?: number | string) =>
                  value !== undefined && value !== null && value !== ''
                    ? `${String(value)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    : ''
                }
                parser={(value?: string) => {
                  const cleaned = String(value ?? '').replace(/\$\s?|(,*)/g, '')
                  return cleaned === '' ? undefined : Number(cleaned)
                }}
                min={0}
                step={1}
                precision={0}
                placeholder="0"
                onChange={(val) => {
                  // เมื่อผู้ใช้ลบค่า ให้เก็บเป็น undefined (ไม่แสดงเป็น 0)
                  if (val === null || val === undefined || val === '') {
                    form.setFieldsValue({ amountMax: undefined })
                  }

                  form.setFieldsValue({ amountMax: val })
                }}
              />
            </FormItem>
          </AmountWrapper>
        </BodyStyled>
      </Form>
    </Modal>
  )
}
